<template>
	<div class="sg-center-padding" style="padding-bottom: 30px">
		<div id="shouye">
			<vehicle-swiper-inform
				ref="first"
				:tab-type="tabType"
				@scroll="handleScroll"
				@login="loginDialogVisible = $event"
				:listActivity="listActivity"
			/>
		</div>
		<div id="activity" class="activity-box" v-if="Name != ''">
			<activity ref="second" />
		</div>
		<div class="shop-box">
			<shop ref="third" id="shop" />
		</div>
		<div class="vehicle-source">
			<vehicle-source ref="fourth" id="source" />
		</div>
		<div class="auction-wrap">
			<auction ref="fifth" id="auction" />
		</div>
		<div class="right-wrap">
			<right-menu
				@scroll="handleScroll"
				:tab-type="tabType"
				:listActivity="listActivity"
			/>
		</div>
		<recommend />
	</div>
</template>
<script>
import {TopActiveBanner} from "@/api/activity.js"
import {
	// GetSuperiorItemList,
	// GetQualityItemList,
	IndexLogin
	// QueryVehicleAuction,
	// QueryAutoPartsAuction,
	// QueryStandingAuction,
	// QueryWeightAuction,
	// IndexUnLogin
} from "@/api/merchant/dashboard"
import {mapState} from "vuex"
import vueSeamlessScroll from "vue-seamless-scroll"
import VehicleSwiperInform from "./components/vehicleSwiperInform"
import Activity from "./components/activity"
import Shop from "./components/shop"
import VehicleSource from "./components/source"
import Auction from "./components/auction"
import Recommend from "./components/recommend"
import ScrollIntoView from "@/utils/mixins/scrollIntoView.js"
import RightMenu from "./components/rightMenu"
import {GetMyProfile} from "@/api/user.js"
export default {
	mixins: [ScrollIntoView],
	components: {
		vueSeamlessScroll,
		VehicleSwiperInform,
		Activity,
		Shop,
		VehicleSource,
		Auction,
		Recommend,
		RightMenu
	},
	data() {
		return {
			Name: "",
			// tabIndex: 0,
			// carouselIndex: 0,
			// xunjiaDialogVisible: false,
			// peiqiDialogVisible: false,
			// youPinList: [], //诚信优品
			// yanxuanList: [], //严选速达
			// jinPinList: [], //精品车源
			// daichaiList: [], //配件待拆
			// yichaiList: [], //配件已拆
			// fadongjiList: [], //发动机
			// youseList: [], //有色
			// goodsList: [],
			// groupGoodsList: [],
			// listData: [1, 2, 3, 4, 5, 6],
			classOption: {
				limitMoveNum: 3,
				singleWidth: 198,
				direction: 2
			},
			list: [],
			listActivity: [] //活动
			// shopDetailObj: null, //商城配件详情
		}
	},
	provide: function () {
		return {
			getShopList: () => this.list.Item1,
			getSourceList: () => this.list.Item2,
			getAuctionList: () => this.list.Item3,
			getRecommendList: () => this.list.Item4
		}
	},

	created() {
		TopActiveBanner().then((res) => {
			this.listActivity = res
			this.Name = this.listActivity[1].Name
			console.log(this.listActivity[1].Name)
			console.log(res)
		})
		// setInterval(() => {
		// 	GetMyProfile().then((res) => {
		// 		console.log(res)
		// 	})
		// }, 100)
		this.$store.dispatch("merchant/getCartNum")
		// GetSuperiorItemList({ PageIndex: 1, PageSize: 20 }).then((res) => {
		//   this.youPinList = this.group(res.List, 3);
		// });
		// GetQualityItemList({ PageIndex: 1, PageSize: 20 }).then((res) => {
		//   this.yanxuanList = this.group(res.List, 3);
		// });
		IndexLogin({Brower: "PC"}).then((res) => {
			this.list = res
			// this.jinPinList = res.Item2;
		})
		// QueryVehicleAuction({ PageIndex: 1, PageSize: 20 }).then((res) => {
		//   this.daichaiList = this.group(res.List, 3);
		// });
		// QueryAutoPartsAuction({ PageIndex: 1, PageSize: 20 }).then((res) => {
		//   this.yichaiList = this.group(res.List, 3);
		// });
		// QueryStandingAuction({ PageIndex: 1, PageSize: 20 }).then((res) => {
		//   this.fadongjiList = this.group(res.List, 3);
		// });
		// QueryWeightAuction({ PageIndex: 1, PageSize: 20 }).then((res) => {
		//   this.youseList = this.group(res.List, 3);
		// });
		// IndexUnLogin({ Browser: "PC" }).then((res) => {

		//   // Object.keys(res).forEach((item) => {
		//   //   res[item] = {
		//   //     firstObj: {},
		//   //     endObj: res[item].pop(),
		//   //     middleList: res[item].slice(0),
		//   //   };
		//   // });

		//   this.list = res;
		//   debugger
		// });
		// let array = [];
		// for (let i = 0; i < 100; i++) {
		//   array.push(0);
		// }

		// this.goodsList = array;
		// this.groupGoodsList = this.group(array, 3);
	},
	computed: {
		// bgStyle() {
		//   if (this.carouselIndex == 0) {
		//     return { "background-color": "rgb(0, 1, 111)" };
		//   } else {
		//     return { "background-color": "rgb(17, 143, 47)" };
		//   }
		// },
		...mapState({
			// name: (state) => state.user.name
			name: (state) =>
				state.user.name != "" ? state.user.name : "暂未填写用户名"
		})
	},
	watch: {
		$route(route) {
			debugger
			if ((to.name == from.name) == "dashboard") {
				this.$nextTick(() => {
					location.reload()
				})
			}
		}
	},

	methods: {
		handleScroll(val) {
			this.tabType = val
			this.scrollToElePosition(val)
		}
		// handleCarouselChange(e) {
		//   this.carouselIndex = e;
		// },
		// group(array, subGroupLength) {
		//   let index = 0;
		//   let newArray = [];
		//   while (index < array.length) {
		//     newArray.push(array.slice(index, (index += subGroupLength)));
		//   }
		//   return newArray;
		// },
		// handleToList(type) {
		//   this.$router.push(`/parts-list/${type}`);
		// },
		// handleToDetail(item) {
		//   // const {id}=item
		//   let id = "2222";
		//   this.$router.push("/parts-detail/${id}");
		// },
		// handleToPartsDetail(e) {
		//   this.shopDetailObj=e
		//   this.$router.push("/parts-detail");
		// },
	}
	//   beforeRouteEnter(to,from,next) {
	//     debugger
	//     next((vm) => {
	//       // 通过 `vm` 访问组件实例
	//     });
	//   },
	// beforeDestroy() {
	//   debugger;
	//   // this.$bus.$emit("data", this.shopDetailObj);
	// },
}
</script>
<style lang="scss" scoped>
.activity-box {
	margin-top: 16px;
}
.shop-box {
	margin-top: 15px;
}
.vehicle-source {
	margin-top: 21px;
}
.right-wrap {
	position: fixed;
	right: 5%;
	top: 50%;
	transform: translateY(-50%);
	z-index: 9;
}
// .single-ellipse {
//   overflow: hidden;
//   white-space: nowrap;
//   text-overflow: ellipsis;
// }
// .full-screen-top {
//   background-color: #fff;
//   display: inline-block;
//   width: 100%;
//   // overflow: hidden;
//   .sg-nav {
//     position: relative;
//     height: 380px;
//     margin-top: 46px;
//   }
//   .nav-home {
//     z-index: 20;
//     position: absolute;
//     top: -36px;
//     width: 100%;
//     left: 0;
//     .nav {
//       float: left;
//       padding: 0 20px;
//       li {
//         float: left;
//         .a {
//           height: 36px;
//           padding: 0 20px;
//           color: #333;
//           font-size: 15px;
//           line-height: 36px;
//           &.active {
//             color: #ff4f1a;
//             font-weight: bold;
//           }
//         }
//       }
//     }
//   }
// }
// .sg-main {
//   margin-top: 10px;
//   .qrcode-wrap {
//     position: relative;
//     height: 118px;
//     margin-top: 10px;
//     background: url(~@/assets/qr-bg.png) no-repeat;
//     background-size: cover;
//     background-position: center;
//     > img {
//       position: absolute;
//       top: 19px;
//       right: 18.5%;
//       width: 94px;
//       height: 94px;
//     }
//   }
//   .module-title {
//     padding-bottom: 20px;
//     s {
//       float: left;
//       width: 3px;
//       height: 22px;
//       margin-top: 7px;
//       margin-right: 6px;
//       background: #ff4f1a;
//     }
//     b {
//       margin-right: 12px;
//       font-size: 24px;
//     }
//     span {
//       position: relative;
//       top: -3px;
//       font-size: 14px;
//     }
//   }
//   .fl {
//     float: left;
//   }
//   .fr {
//     float: right;
//   }
//   .mall-wrap,
//   .jingpin-wrap,
//   .auction-wrap {
//     padding-top: 32px;
//     .goods-content {
//       .goods-item {
//         padding: 0 10px;
//         display: inline-block;
//         // background-color: red;
//         .good-img {
//           text-align: center;
//           // padding: 10px;
//         }
//         .good-title {
//           line-height: 20px;
//           height: 20px;
//           font-size: 14px;
//           padding: 0;
//         }
//         .car-type {
//           height: 20px;
//           line-height: 20px;
//           color: #999;
//           font-size: 14px;
//         }
//         .price-box {
//           height: 24px;
//           line-height: 24px;
//           color: #ff4f1a;
//           span {
//             margin-right: 5px;
//           }
//           b {
//             font-size: 18px;
//           }
//         }
//       }
//     }

//     .three-goods-wrap {
//       background: #fff;
//       cursor: pointer;
//       width: calc(50% - 5px);
//       .goods-content {
//         display: grid;
//         grid-template-columns: repeat(3, minmax(170px, 1fr));
//       }

//       &:nth-of-type(1) {
//         h3 {
//           b,
//           .desc {
//             color: #55b960;
//           }
//           .desc {
//             border: 1px solid #55b960;
//           }
//         }
//       }
//       &:nth-of-type(2) {
//         h3 {
//           b,
//           .desc {
//             color: #ff4f1a;
//           }
//           .desc {
//             border: 1px solid #ff4f1a;
//           }
//         }
//       }
//       &:nth-of-type(3) {
//         margin-right: 10px;
//         h3 {
//           b,
//           .desc {
//             color: #55b960;
//           }
//           .desc {
//             border: 1px solid #55b960;
//           }
//         }
//       }
//       &:nth-of-type(4) {
//         h3 {
//           b,
//           .desc {
//             color: #ff4f1a;
//           }
//           .desc {
//             border: 1px solid #ff4f1a;
//           }
//         }
//       }
//       &:nth-of-type(3),
//       &:nth-of-type(4) {
//         margin-top: 10px;
//       }
//       h3 {
//         height: 64px;
//         padding: 0 20px 0 16px;
//         line-height: 64px;
//         > b {
//           font-size: 20px;
//           color: #333;
//           //   &:nth-of-type(1) {
//           //     color: #55b960;
//           //   }
//         }
//         > span {
//           position: relative;
//           top: -2px;
//           display: inline-block;
//           height: 22px;
//           padding: 0 4px;
//           border-radius: 4px;
//           margin-left: 8px;
//           line-height: 22px;
//           //   &:nth-of-type(1) {
//           //     border: 1px solid #55b960;
//           //     color: #55b960;
//           //   }
//         }
//         .more-wrap {
//           color: #999;
//           font-size: 14px;
//           cursor: pointer;
//         }
//       }
//       .list-wrap {
//         padding: 0 20px 10px;
//       }
//       &:nth-of-type(1) {
//         margin-right: 10px;
//       }
//     }
//   }

//   .jingpin-wrap {
//     .icon-zone-hottop {
//       width: 190px;
//       height: 282px;
//     }
//     .jinpin-list-wrap {
//       white-space: nowrap;
//       width: calc(100% - 190px);
//       background: #fff;

//       .goods-content {
//         overflow: hidden;
//         .goods-item {
//           -webkit-box-sizing: border-box;
//           box-sizing: border-box;
//           width: 170px;
//           height: 282px;
//           padding: 20px 0;
//           margin-left: 28px;
//           background: #fff;
//           cursor: pointer;
//           .price-box {
//             height: 30px;
//             line-height: 30px;
//             text-align: center;
//           }
//           .good-info {
//             padding: 4px 8px;
//             border-radius: 4px;
//             background: rgba(250, 151, 0, 0.1);
//             text-align: center;
//           }
//         }
//         // .good-img {
//         //   padding: 0;
//         // }
//       }
//       .goods-content {
//         overflow: hidden;
//         .goods-item {
//           -webkit-box-sizing: border-box;
//           box-sizing: border-box;
//           width: 170px;
//           height: 282px;
//           padding: 20px 0;
//           margin-left: 28px;
//           background: #fff;
//           cursor: pointer;
//           .price-box {
//             height: 30px;
//             line-height: 30px;
//             text-align: center;
//           }
//           .good-info {
//             padding: 4px 8px;
//             border-radius: 4px;
//             background: rgba(250, 151, 0, 0.1);
//             text-align: center;
//           }
//         }
//         // .good-img {
//         //   padding: 0;
//         // }
//       }
//     }
//   }
// }
// .peiqi-bg {
//   position: relative;
//   height: 400px;
//   background: url(~@/assets/peiqi-bg2.png) no-repeat;
//   background-size: cover;
//   background-position: center;
//   padding-top: 280px;
//   .peiqi-wrap {
//     position: absolute;
//     top: 70px;
//     left: 50%;
//     width: 200px;
//     height: 200px;
//     -webkit-transform: translate(-50%, 0);
//     -ms-transform: translate(-50%, 0);
//     transform: translate(-50%, 0);
//   }
//   .peiqi-desc {
//     padding-top: 30px;
//     color: #333;
//     font-size: 14px;
//     text-align: center;
//     > h4 {
//       font-weight: bold;
//       font-size: 18px;
//       line-height: 30px;
//     }
//     > p {
//       margin-top: 6px;
//       span {
//         font-weight: bold;
//       }
//     }
//   }
// }
</style>
<style lang="scss">
// .full-screen-top {
//   .el-carousel__container {
//     // padding: 0 calc(50% - 30vw);
//     position: static;
//   }
//   .el-carousel__item {
//     .bg-image {
//       background-repeat: no-repeat;
//       background-size: contain;
//       background-position: center;
//       height: 100%;
//     }
//     &:nth-child(1) {
//       .bg-image {
//         background-color: rgb(0, 1, 111);
//         background-image: url(~@/assets/img1.webp);
//       }
//     }
//     &:nth-child(2) {
//       .bg-image {
//         background-color: rgb(17, 143, 47);
//         background-image: url(~@/assets/img2.webp);
//       }
//     }
//   }
// }
</style>
